import { render, staticRenderFns } from "./DialogEditRecebimentoDefinido.vue?vue&type=template&id=d8d1fbfa&scoped=true"
import script from "./DialogEditRecebimentoDefinido.vue?vue&type=script&lang=js"
export * from "./DialogEditRecebimentoDefinido.vue?vue&type=script&lang=js"
import style0 from "./DialogEditRecebimentoDefinido.vue?vue&type=style&index=0&id=d8d1fbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d1fbfa",
  null
  
)

export default component.exports